import { CommonModule } from '@angular/common';
import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  Output,
  Renderer2,
  ViewChild,
} from '@angular/core';
import { CapturedPhoto } from '@core/models';
import { PhotoCaptureComponent } from '../photo-capture/photo-capture.component';
// import { PhotoCaptureComponent } from '@shared/components';

@Component({
  selector: 'app-evidence-modal',
  imports: [CommonModule, PhotoCaptureComponent],
  templateUrl: './evidence-modal.component.html',
  styleUrl: './evidence-modal.component.scss',
})
export class EvidenceModalComponent implements OnDestroy {
  @Input() title = 'Evidencias del vehículo';
  @Input() photos: CapturedPhoto[] = [];
  @Input() minPhotos = 3;
  @Input() maxPhotos = 5;
  @Input() showMiniatures = true;
  @Input() fileNamePrefix = 'reception';

  @Output() photosChange = new EventEmitter<CapturedPhoto[]>();

  @ViewChild('modal') private modal?: ElementRef<HTMLDialogElement>;

  private scrollPosition = 0;

  constructor(private readonly renderer: Renderer2) {}

  ngOnDestroy(): void {
    this.unlockBodyScroll();
  }

  openModal(): void {
    if (this.modal?.nativeElement.open) return;

    this.modal?.nativeElement.showModal();
    this.lockBodyScroll();
  }

  closeModal(): void {
    this.modal?.nativeElement.close();
  }

  onDialogClosed(): void {
    this.unlockBodyScroll();
  }

  onPhotosChanged(nextPhotos: CapturedPhoto[]): void {
    this.photosChange.emit(nextPhotos);
  }

  private lockBodyScroll(): void {
    this.scrollPosition = window.scrollY;

    this.renderer.setStyle(document.body, 'position', 'fixed');
    this.renderer.setStyle(document.body, 'top', `-${this.scrollPosition}px`);
    this.renderer.setStyle(document.body, 'left', '0');
    this.renderer.setStyle(document.body, 'right', '0');
    this.renderer.setStyle(document.body, 'width', '100%');
  }

  private unlockBodyScroll(): void {
    this.renderer.removeStyle(document.body, 'position');
    this.renderer.removeStyle(document.body, 'top');
    this.renderer.removeStyle(document.body, 'left');
    this.renderer.removeStyle(document.body, 'right');
    this.renderer.removeStyle(document.body, 'width');

    window.scrollTo(0, this.scrollPosition);
  }
}
